export default "__VITE_ASSET__CoU0JRt7__"